import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import { authGuard } from "@/auth";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/customers",
      name: "Customers",
      beforeEnter: authGuard,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/Customers.vue")
    },
    {
      path: "/excluded-customers",
      name: "ExcludedCustomers",
      beforeEnter: authGuard,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/excludedCustomers.vue")
    },
    {
      path: "/groups",
      name: "Groups",
      beforeEnter: authGuard,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/Groups.vue")
    },
    {
      path: "/reminders",
      name: "Reminders",
      beforeEnter: authGuard,
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/Reminders.vue")
    },
    {
      path: "/templates",
      name: "Templates",
      beforeEnter: authGuard,
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/Templates.vue")
    },
    {
      path: "/assign-templates",
      name: "Assign Templates",
      beforeEnter: authGuard,
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/AssignTemplates.vue")
    },
    {
      path: "/letter-templates",
      name: "Letter Templates",
      beforeEnter: authGuard,
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/LetterTemplates.vue")
    },
    {
      path: "/send-letters",
      name: "Send Letters",
      beforeEnter: authGuard,
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/SendLetters.vue")
    },
    {
      path: "/audit-logs",
      name: "AuditLogs",
      beforeEnter: authGuard,
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/Audit.vue")
    },
    {
      path: "/dispute",
      name: "DisputeView",
      beforeEnter: authGuard,
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/Dispute.vue")
    },
    {
      path: "/early-termination-fee",
      name: "EarlyTerminationFee",
      beforeEnter: authGuard,
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/EarlyTerminationFee.vue")
    }
  ]
});
